
import { Component, HostListener, OnInit, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ThemeSwitcherService, FlowService, AuthService } from '@mapfre-tech/amap3';
import { NotifyService, VersionService, DateService } from '@mapfre-tech/amap3';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import moment from 'moment';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType  } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { environment } from "../environments/environment";
import { PrimeNG } from 'primeng/config';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'mapfre-auditweb-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {

  visible;
  modal;
  version;

  keys = "";
  mks = {
    "audit": [],
    "map": [],
    "three": []
  }

  inactivityLimit;
  private readonly _destroying$ = new Subject<void>();
  timeLeft;
  showInactivityModal;

  renderApp;
  isIframe = false;

  constructor(private versionService: VersionService,
    private translate: TranslateService, 
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private themeSwicther: ThemeSwitcherService,
    private notifyService: NotifyService,
    private flowService: FlowService, 
    private router: Router,
    private dateService: DateService,
    private authService: MsalService,
    private authCustomService: AuthService,
    private msalBroadcastService: MsalBroadcastService,
    private primeNGConfig: PrimeNG) {

    this.translate.onLangChange.subscribe(res => {
      this.renderApp = true;
    })

    this.checkExecution()

    this.themeSwicther.changeTheme('CoreTheme');
    this.notifyService.observer.subscribe((msg) => {
      if (msg!= null && msg.key === 'changeModalVisibility') {
        this.visible = msg.data;
        this.modal = msg.modal;
      }
    });

    window.onbeforeunload = (event) => {
      if (this.flowService.getUnsaved()) {
        event.returnValue = ""
      }
    }
    setInterval(() => {
      if (!_.includes(this.router.url, 'create')) {
        this.flowService.setUnsaved(false);
      }
    }, 45 * 1000)

    this.restartTimerInactivity()
    setInterval(() => {
      const currentTime = moment();
      const duration = moment.duration(this.inactivityLimit.diff(currentTime));
      let minutes: any = duration.minutes()
      let seconds: any = duration.seconds();
      if (minutes <= 0 && seconds <= 0 && this.authCustomService.isLogged()) {
        this.showInactivityModal = false;
        this.authService.logout();
      } else if (minutes <= 0 && seconds <= 30 && this.authCustomService.isLogged()) {
        this.showInactivityModal = true;
      }
      minutes = minutes > 9 ? minutes.toString() : 0 + minutes.toString();
      seconds = seconds > 9 ? seconds.toString() : 0 + seconds.toString();
      this.timeLeft = `${minutes}:${seconds}`;
    }, 1000)
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe((res) => {
        this.checkAndSetActiveAccount();
      })
  }

  ngOnDestry() {
    this.authCustomService.deInitMsal();
  }

  sendResponse(value) {
    this.notifyService.notify({ key: 'changeModalConfirmation', data: value });
  }

  getAllVersions() {
    this.versionService.getAllVersions().subscribe((version) => {
      this.version = version;
    });
  }

  @HostListener('window:click', ['$event'])
  onClick(event) {
    this.restartTimerInactivity();
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event) {
    this.restartTimerInactivity();
  }

  restartTimerInactivity() {
    this.inactivityLimit = moment().add(environment.MAX_INACTIVITY_MINUTES, 'minutes');
    this.showInactivityModal = false;
  }

  checkExecution() {
    this.dateService.setAccessDate();
    if(this.authService.instance.getActiveAccount()){
      this.translate.use(localStorage.getItem(`language`) || 'es');
      this.translate.get('primeng').subscribe(res => this.primeNGConfig.setTranslation(res));
    }else {
      this.translate.use("es");
    }
  }

  checkAndSetActiveAccount(){
    /**
     * If no active account set but there are accounts signed in, sets first account to active account
     * To use active account set here, subscribe to inProgress$ first in your component
     * Note: Basic usage demonstrated. Your app may require more complicated account selection logic
     */
    const activeAccount = this.authService.instance.getActiveAccount();

    if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
      const accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
      this.authCustomService.setConfigLogin()
    }

  }

  loginRedirect() {
    if (this.msalGuardConfig.authRequest){
      this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  logout() {
    this.authService.logoutRedirect();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

}